import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'specCategoryFilter',
    pure: false
})

export class SpecCategoryFilterPipe implements PipeTransform {
    transform(items: any[], filter: any): any {
        if (!items || !filter) {
            return items;
        }
        return items.filter(item => item.category === filter.category);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/spec-category.pipe.ts